import { SET_IS_CLASSIC_THEME } from "./themeActionTypes";

export const setIsClassicTheme = (isClassicTheme: boolean) => ({
    type: SET_IS_CLASSIC_THEME,
    isClassicTheme,
});
